'use client'

import { useGlobalState } from '@biolumina/ui/context/globalStateProvider'
import { StyledAnchor } from "./anchor.styles"

export const Anchor = (props) => {
  const { scrollMargin } = useGlobalState()

  return (
    <StyledAnchor {...props} offset={scrollMargin} />
  )
}